module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00023-fs8.7f9065b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00023-fs8.png
// module id = 176
// module chunks = 0